Auth = require 'db/auth'
ChangeLogoPopoverView = require 'views/organization/change-logo-popover-view'
Format = require 'lib/markdown/format'
Accounts = require 'lib/accounts'
PopOver = require 'views/lib/pop-over'
TabbedPaneView = require 'views/internal/tabbed-pane-view'
Util = require 'lib/util'
View = require 'view'
mixin = require 'lib/mixin'
orgDetailProfileTemplate = require 'views/templates/org_detail_profile_info'
templates = require 'views/internal/templates'
track = require 'debug/track'
localizeServerError = require 'lib/localize-server-error'
l = require 'lib/localize'
logError = require 'debug/log-error'
xtend = require 'xtend'
orgDetailTemplate = require 'views/templates/org_detail'
moment = require 'moment'
ClientConfig = require 'debug/client-config'

module.exports = class OrganizationView extends View
  mixin TabbedPaneView, @

  initialize: ->
    @makeDebouncedMethods 'render'
    @listenTo @model, 'change:logoHash change:products change:paidAccount change:prefs change:name', @render
    @listenTo @model, 'change:name change:displayName change:website change:desc', @renderDetails
    @listenTo @model, 'change:memberships', @membershipChange
    @listenTo @model.memberList, 'add remove reset', @renderDebounced

    # Since this is the view that they can change the org name on, help them
    # out by also updating the URL so it works as expected if they refresh
    @listenTo @model, 'change:name', =>
      newPath = location.pathname.replace(/[^\/]+/, @model.get('name'))
      history.replaceState(null, null, newPath)

    @memberTypeMe = @model.getMemberType(Auth.me())
    return

  events:
    'click .js-change-org-logo': 'changeLogoInProfile'
    'click .js-edit-profile': 'editProfile'
    'click .js-submit-profile': 'submitProfile'
    'submit .js-profile-form': 'submitProfile'
    'click .js-cancel-edit-profile': 'cancelEditProfile'

    'click .tabbed-pane-nav-item-button:not(.active)': 'switchSection'

  isFullWidth: -> false

  render: ->
    data = @model.toJSON(prefs: true, url: true, premium: true)
    if @model.editable()
      standing = data.paidAccount?.standing
      data.hasAccount = Accounts.hasAccount(standing)
      data.accountActive = Accounts.isActive(data.paidAccount)
      data.accountProblem = Accounts.isProblem(standing)
      data.accountInactive = Accounts.isInactive(standing)
    data.isInOrg = @model.isMember(Auth.me())
    data.hasBusinessClass = @model.isPremium()
    data.isEnterprise = @model.isEnterprise()
    data.paysWithPurchaseOrder = @model.paysWithPurchaseOrder()
    data.isOrgAdmin = @model.owned()
    data.isBusinessClassAdmin = @model.isPremium() and @model.owned()
    data.pLevelAltText = l(['org perms', @model.getPermLevel(), 'text'])
    data.pLevelDisplayText = l(['org perms', @model.getPermLevel(), 'name'])
    data.websiteHref = Util.sanitizeWebAddress(data.website)
    data.descriptionHtml = Format.markdownAsHtml(data.desc, { textData: data.descData })
    data.isFullWidth = @isFullWidth()
    data.editable = @model.editable()
    data.hasUnlimitedPowerUps = @model.isFeatureEnabled('plugins')
    data.upsellEnabled = !ClientConfig.get('dontUpsell')

    @$el.empty()
    @$el.html orgDetailTemplate(data)

    @renderDetails()

    @renderMainContent()

    @

  renderDetails: ->
    data = @model.toJSON(prefs: true, url: true, premium: true)
    data.enterpriseUI = @model.isFeatureEnabled('enterpriseUI')
    data.isBusinessClass = @model.isPremium()
    data.isOrgAdmin = @model.owned()
    data.pLevelAltText = l(['org perms', @model.getPermLevel(), 'text'])
    data.pLevelDisplayText = l(['org perms', @model.getPermLevel(), 'name'])
    data.websiteHref = Util.sanitizeWebAddress(data.website)
    data.descriptionHtml = Format.markdownAsHtml(data.desc, { textData: data.descData })
    data.canEdit = @model.owned()

    @$('.js-current-details').html(orgDetailProfileTemplate(data))

    if @model.editable()
      @$('.js-profile-form').empty().append(
        templates.fill(
          'org_detail_profile_edit',
          data,
          { editable: @model.editable() }
        )
      )

    @

  delegateEvents: (events) ->
    super(xtend(OrganizationView::events, events || @events))

  membershipChange: ->
    memberTypeMe = @model.getMemberType(Auth.me())

    if memberTypeMe != @memberTypeMe
      @memberTypeMe = memberTypeMe
      @render()

  setActiveView: (sClass) ->
    @$('.tabbed-pane-nav-item-button').removeClass('active')
    @$(sClass).addClass('active')
    return

  changeLogoInProfile: (e) ->
    Util.stop(e)
    track("Organization View", "Open Change Logo Menu from Profile Image")

    PopOver.toggle
      elem: @$('.js-change-org-logo')
      view: new ChangeLogoPopoverView({ @model, @modelCache })

    return

  editProfile: (e) ->
    Util.stop(e)

    @$('.js-current-details').addClass('hide')
    @$('.js-profile-form').removeClass('hide')

    track("Organization View", "Click Edit Profile")
    return

  cancelEditProfile: (e) ->
    Util.stop(e)
    @$('.js-current-details').removeClass('hide')
    @$('.js-profile-form').addClass('hide')
    @$('.js-profile-form')[0].reset()
    track("Organization View", "Cancel Edit Profile")
    return

  submitProfile: (e) ->
    Util.stop(e)

    # we're probably waiting on the server after submission. just a sec.
    return if @disabled

    data = {}
    for field in ['displayName', 'name', 'website', 'desc']
      data[field] = @$(".js-profile-form [name=#{field}]").val()

    data.name = data.name.toLowerCase().replace(/[^a-z0-9_]/g, "")
    for field in ['displayName', 'website']
      data[field] = data[field].trim()

    # disable submitting while we wait for the server.
    @disableSubmit()

    @model.update data, waitForServer: true, (err) =>

      # okay, re-enable submit
      @disabled = false
      @$('.js-submit-profile').removeAttr('disabled')

      if err
        trimmedErrorMsg = err.message.trim().toLowerCase()
        @$('.js-profile-form-error')
          .removeClass('hide')
          .text(localizeServerError(trimmedErrorMsg))
      else
        @$('.js-profile-form-error').addClass('hide')
        @cancelEditProfile()
        track("Organization View", "Changed Name and Details")
      return

    return

  disableSubmit: ->
    @disabled = true
    @$('.js-submit-profile').attr('disabled', 'disabled')
    return



// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-view.coffee